const SgiFormInputNumberEO = function () {
    return {
        alwBlk: true,
        // c:"desId",
        ctlH: 0,
        ctlN: "数字",
        ctlW: 24,
        dcmDgt: 2, // 小数位
        desId: "EP_EO_UI_3104",
        inpPopTe: "请输入数字", // 输入提示文本
        isDis: false,
        isHdn: false,
        lblW: 6,
        maxV: 9999, // 输入最大值
        minV: 0, // 输入最小值
        step: 1, //微调的数字间距
        te: "数字",
        selectType:"00",//添加符号
        isLbl: false,
        lblAlg: "right",
        // isRead:false,
        // msfTgt:"qtip",

        // isHdnTg:false, // 是否隐藏微调
        // intDgt:0, // 整数位
        maxL: 0, // 最大输入长度
        minL: 0, // 最小输入长度
        // isSrp:true, //x键盘过滤状态
        // isGw:false, //延伸状态
        // n:"描述GUID",
        // sNo:10,
        // t:"num",
        // useTim:0,
        // visible:true,
        // x:"0",
        // y:"0",
    }
}

export { SgiFormInputNumberEO };
export default SgiFormInputNumberEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormInputNumberEO.js